import {CommonMessages} from '../common.messages';

export const AssignClientAccountRightsMessages = {
    AssignRightsFailed: {
        key: 'AssignRightsFailed',
        message: 'Assign rights for account with reference <<reference>> failed.'
    },
    AssignRightsCheckForExistenceFailed: {
        key: 'AssignRightsCheckForExistenceFailed',
        message: 'Unable to check either selected user has already assigned access to current account.'
    },
    AssignRightsCheckForExistenceNotPassed: {
        key: 'AssignRightsCheckForExistenceNotPassed',
        message: 'Selected user already has assigned access to current account.'
    },
    AssignRightsSucceed: {
        key: 'AssignRightsSucceed',
        message: 'Rights for account with reference <<reference>> are successfully assigned.'
    },
    ...CommonMessages
};
